import { useCallback, useEffect, useMemo, useState } from "react";
import { A11yContext } from "../hooks/useA11y.js";
import { A11Y_OFF, getA11yAttributes, isA11yActive, toggleA11yFeature } from "../utils/a11y.js";

// SOK-09: el modo accesible dura solo la sesión de compra: no se guarda en localStorage y App lo
// reinicia al vaciar el carro (fin de venta, carro vaciado o inactividad).
export function A11yProvider({ children }) {
  const [settings, setSettings] = useState(A11Y_OFF);
  const active = isA11yActive(settings);

  useEffect(() => {
    const root = document.documentElement;
    Object.entries(getA11yAttributes(settings)).forEach(([name, value]) => {
      if (value == null) root.removeAttribute(name);
      else root.setAttribute(name, value);
    });
  }, [settings]);

  const toggle = useCallback((key) => setSettings((previous) => toggleA11yFeature(previous, key)), []);
  const reset = useCallback(() => setSettings(A11Y_OFF), []);

  const value = useMemo(() => ({ settings, active, toggle, reset }), [settings, active, toggle, reset]);

  return (
    <A11yContext.Provider value={value}>
      {children}
    </A11yContext.Provider>
  );
}
